import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';
import useAppSelector from 'packages/hooks/use-app-selector';
import React from 'react';
import {selectFileBlob} from 'redux/features/app-slice';
import SponsorList from './SponsorList';

const Settings = (props: DialogProps) => {
  const {modalOpen, toggle} = props;
  const localAddedBlobs = useAppSelector(selectFileBlob); // Images added that will be used to render the sponsors of the tournament
  return (
    <>
      <Dialog open={modalOpen} onClose={toggle} aria-labelledby="">
        <DialogTitle id="settings-dialog-title">Patrocinadores</DialogTitle>
        <DialogContent>
          Para añadir una nueva configuración haz click en agregar sponsor. Solo
          puedes agregar máximo 5 sponsors.
          <SponsorList disposeModal={toggle} sponsorList={localAddedBlobs} />
        </DialogContent>
        <DialogActions>
          <Button onClick={toggle} color="default">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Settings;
